<template>
  <div class="shop">
    <p>
      <label>Formulaire de commande NIKE : de U6 / U7 à U17 </label>
      <a class="link" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSc-fLxuyhRLscBcqXI8vjxEkRBD4UhIbgOMP3J_az1rGKhzCw/viewform">PRE COMMANDE EQUIPEMENTS (Short / Chaussettes pour matchs)</a>
      <br/>
      <v-img src="https://www.asspm.fr/lab/data/apps/asspm/images/chaussettes.png"/>
      <v-img src="https://www.asspm.fr/lab/data/apps/asspm/images/short.png"/>
      <v-img src="https://www.asspm.fr/lab/data/apps/asspm/images/maillot_1.png"/>
    </p>

    <p>
      <label>Formulaire de commande KAPPA <strong>(Réservé SENIORS et U18 / U19)</strong> : </label>
      <a class="link" target="_blank" href="https://docs.google.com/forms/d/1qn9EVfzEGbTZWgTqT7mKq54aV67418M4xQGA0PKulsk/viewform">PRE COMMANDE EQUIPEMENTS (Short / Chaussettes pour matchs)</a>
      <br/>
      <v-img src="https://www.asspm.fr/lab/data/apps/asspm/images/chaussettes.png"/>
      <v-img src="https://www.asspm.fr/lab/data/apps/asspm/images/short.png"/>
      <v-img src="https://www.asspm.fr/lab/data/apps/asspm/images/maillot_1.png"/>
    </p>

    <a target="_blank" :href="item.tarifs_boutique">
      <pdf ref="pdf" :src="item.tarifs_boutique" :resize="true" :text="false">
        <template slot="loading">
        </template>
      </pdf>
    </a>
    
    <a target="_blank" :href="item.tarifs_location_asspm">
      <pdf ref="pdf" :src="item.tarifs_location_asspm" :resize="true" :text="false">
        <template slot="loading">
        </template>
      </pdf>
    </a>
    
  </div>
</template>
<style scoped lang="stylus">
  #app
    p
      text-align center
    a.link
      text-decoration underline
</style>

<script>

  import pdf from 'pdfvuer'
  import MetaService from '../../services/meta.service'

  const META_INFO = {
    title : "La boutique",
    image : "https://www.asspm.fr/lab/data/apps/asspm/files/2020/08/75580410_2467882063301685_1986581640377270272_n.jpg",
    description : "La boutique du club de football de l'Avenir Sport Saint Pierre Montrevault",
  }

  export default {
    name: 'Shop',
    metaInfo() {
      if (!this.sendMetaInfo) return
      return MetaService.info(META_INFO)
    },
    mounted() {
      this.sendMetaInfo = true
    },
    components: {
      pdf
    },
    data() {
      return {
        item: {
          tarifs_location_asspm: "https://www.asspm.fr/rubriques/tarifs_location_asspm.pdf"
          , tarifs_boutique: "https://www.asspm.fr/rubriques/tarifs_boutique.pdf"
        }
      }
    }
  }

</script>

<style scoped lang="stylus">
  .shop
    img
      max-width 170px
    .flyer
      max-width 800px
</style>